export default "__VITE_ASSET__DLFXI006__"